module.exports = __webpack_public_path__ + "static/media/manager.2047cb64.svg";